import { render, staticRenderFns } from "./MinimizedCallModal.vue?vue&type=template&id=916da42a&"
import script from "./MinimizedCallModal.vue?vue&type=script&lang=js&"
export * from "./MinimizedCallModal.vue?vue&type=script&lang=js&"
import style0 from "./MinimizedCallModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports